export const pause = {
	className: 'icon-pause',
	viewBox: '0 0 256 320',
	paths: ['M 71.9,320 8.1,320 C 3.6,320 0,316.4 0,312 L 0,8 C 0,3.6 3.6,0 8.1,0 L 71.9,0 C 76.4,0 80,3.6 80,8 l 0,304 c 0,4.4 -3.6,8 -8.1,8 z m 176,0 -63.8,0 c -4.5,0 -8.1,-3.6 -8.1,-8 L 176,8 c 0,-4.4 3.6,-8 8.1,-8 l 63.8,0 c 4.5,0 8.1,3.6 8.1,8 l 0,304 c 0,4.4 -3.6,8 -8.1,8 z']
}
